import React from 'react';
import {Box, Drawer, Typography, IconButton, CircularProgress} from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import LocationsList from './LocationsList';

const SidebarDrawer = ({open, collapsed, isMobile, isDesktop, loading, data, expandedSite, expandedAsset, darkMode, theme, onDrawerToggle, onCollapseToggle, onSiteClick, onShowAllCameras, onFetchCameras, setExpandedAsset}) => {
	return (
		<>
			{/* Collapse/Expand Button for Desktop */}
			{isDesktop && (
				<IconButton
					onClick={onCollapseToggle}
					size='small'
					aria-label={collapsed ? 'Expand drawer' : 'Collapse drawer'}
					sx={{
						position: 'absolute',
						top: '100px',
						left: collapsed ? '40px' : { md: '300px', lg: '250px', xl: '380px' },
						transform: 'translateX(-50%)',
						borderRadius: '50%',
						background: '#fff',
						padding: '6px',
						color: '#696969',
						transition: 'all 0.3s ease',
						border: '1px solid #64748b',
						zIndex: 1300,
						boxShadow: 2,
					}}
				>
					{collapsed ? <ChevronRightIcon sx={{fontSize: 20}} /> : <ChevronLeftIcon sx={{fontSize: 20}} />}
				</IconButton>
			)}

			<Drawer
				variant={isMobile ? 'temporary' : 'permanent'}
				open={isMobile ? open : !collapsed}
				onClose={onDrawerToggle}
				sx={{
					width: {
						md: collapsed ? '40px' : '300px',
						lg: collapsed ? '40px' : '250px',
						xl: collapsed ? '40px' : '380px',
					},
					flexShrink: 0,
					'& .MuiDrawer-paper': {
						top: {
							xs: '56px',
							sm: '64px',
							md: '72px',
						},
						height: {
							xs: 'calc(100vh - 56px)',
							sm: 'calc(100vh - 64px)',
							md: 'calc(100vh - 72px)',
						},
						width: isMobile ? `calc(100% - 64px)` : collapsed ? '40px' : { md: '300px', lg: '250px', xl: '380px' },
						boxSizing: 'border-box',
						overflowY: 'scroll',
						scrollbarWidth: 'none',
						'&::-webkit-scrollbar': {display: 'none'},
						zIndex: isMobile ? 1300 : 'auto',
						backgroundImage: darkMode ? 'linear-gradient(rgba(26, 26, 46, 0.9), rgba(26, 26, 46, 0.9))' : 'linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9))',
						borderRight: `1px solid ${darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
						transition: theme.transitions.create('width', {
							easing: theme.transitions.easing.sharp,
							duration: theme.transitions.duration.enteringScreen,
						}),
					},
				}}
			>
				{/* Header Title */}
				{!collapsed && (
					<Box sx={{p: 2}}>
						<Typography
							variant='subtitle2'
							sx={{
								fontWeight: 'bold',
								color: darkMode ? 'primary.light' : 'primary.main',
								display: 'flex',
								alignItems: 'center',
								gap: 1,
							}}
						></Typography>
					</Box>
				)}

				{/* Content */}
				{(isDesktop ? !collapsed : true) &&
					(loading ? (
						<Box sx={{display: 'flex', justifyContent: 'center', p: 4}}>
							<CircularProgress size={30} />
						</Box>
					) : (
						<LocationsList
							data={data}
							expandedSite={expandedSite}
							expandedAsset={expandedAsset}
							darkMode={darkMode}
							onSiteClick={onSiteClick}
							onShowAllCameras={onShowAllCameras}
							onFetchCameras={onFetchCameras}
							setExpandedAsset={setExpandedAsset}
						/>
					))}
			</Drawer>
		</>
	);
};

export default SidebarDrawer;
